@use '~/theme/theme' as *;

.categoryTooltip {
  display: flex;
  flex: 1;
  overflow: hidden;

  .categoryLabel {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
